
import store from '../store';

export default function (action, subject) {
	return store.getters.ability.can(action, subject)
}